import createSagaMiddleware from "@redux-saga/core";
import { configureStore } from "@reduxjs/toolkit";
import { SagaMiddleware } from "redux-saga";
import { rootReducer } from "./rootReducer";
import { useDispatch } from "react-redux";
import { rootSaga } from "./rootSaga";

const sagaMiddleware: SagaMiddleware = createSagaMiddleware();
const middlewares = [sagaMiddleware];

const store = configureStore({
    middleware: (getMiddlewares) => {
        return getMiddlewares().concat(middlewares);
    },
    reducer: rootReducer
});

sagaMiddleware.run(rootSaga);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();

export default store;